(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyPaymentLogSearch', CompanyPaymentLogSearch);

    CompanyPaymentLogSearch.$inject = ['$resource'];

    function CompanyPaymentLogSearch($resource) {
        var resourceUrl = 'api/_search/company-payment-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
